import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Text1, Text4, Text5, Text3 } from "../../../styles";
import { handleApiExceptions, getIndianRupeeNotation } from "../../../app_methods";
import { DatePicker, List, Avatar, Icon, Tooltip, Tabs } from 'antd';
import moment from 'moment';
import { isEmpty } from 'lodash';

const MerchantInsightsDrawer = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState({
        month: moment(),
    });
    const [insightsData, setInsightsData] = useState({});

    const { TabPane } = Tabs;
    const fetchInsights = async (_filters = {}) => {
        setIsLoading(true);
        const response = await props.merchant.get_insights({ month: _filters.month ? _filters.month.format("YYYY-MM") : "" });
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setInsightsData(response.data);
        setIsLoading(false);
    };

    const getCountData = (data, status) => {
        if (data){
            const statusData = data && data.totals.find(total => total.status == status);
            return statusData ? statusData.count : 0;
        }
        return 0
    };

    const getCummulativeCount = (data, statuses) => {
        let total = 0
        statuses.map((status) => total += getCountData(data, status))
        return total;
    };

    const getTotalData = (data, status) => {
        if (data){
            const statusData = data && data.totals.find(total => total.status == status);
            return statusData ? parseFloat(statusData.total.toFixed(2)) : 0.00; 
        }
        return 0
    };

    const getCummulativeTotal = (data, statuses) => {
        let total = 0.00
        statuses.map((status) => total += getTotalData(data, status))
        return parseFloat(total).toFixed(2);
    };

    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Merchant Insights</Text1>
                <Text5 className="d-block" type="secondary">{props.merchant.name}</Text5>
            </div>
        )
    };

    const renderFilters = () => {
        return (
            <div className="mb-2 w-100 d-flex align-items-center justify-content-end">
                <Text4 className="d-block mr-2" strong>Month:</Text4>
                <DatePicker.MonthPicker
                    className=""
                    size="small"
                    placeholder="Select month"
                    disabledDate={(date) => date.valueOf() > moment().valueOf()}
                    value={filters.month}
                    format="MMMM, YYYY"
                    allowClear={false}
                    onChange={value => { fetchInsights({ ...filters, month: value }); setFilters({ ...filters, month: value }); }}
                />
            </div>
        )
    };


    const renderListItem = (icon_type, icon_color, label, description) => {
        return <List.Item>
            <List.Item.Meta
                avatar={<Avatar icon={icon_type} style={{ color: icon_color, border: `1px solid ${icon_color}`, backgroundColor: "transparent" }} >{icon_type == ""? '₹' : null }</Avatar>}
                title={<Text4 strong>{label}</Text4>}
                description={description}
            />
        </List.Item>
    } 

    const renderTransferInsights = () => {
        const transfers = insightsData.transfer_requests
        const statuses = ["accepted", "in_process", "success", "failure"]
        const cummulativeTotal = getIndianRupeeNotation(parseFloat(getCummulativeTotal(transfers, statuses)));
        const inProcessTotal = getIndianRupeeNotation(getTotalData(transfers, "in_process"));
        const successTotal = getIndianRupeeNotation(getTotalData(transfers, "success"));
        const failureTotal = getIndianRupeeNotation(getTotalData(transfers, "failure"));
        const earnings = getIndianRupeeNotation(transfers ? transfers.earnings : 0.00 || 0.00);
        const payable_commission = getIndianRupeeNotation(transfers ? transfers.payable_commission : 0.00 || 0.00);

        return (
            <List itemLayout="horizontal" loading={isLoading}>
                {renderListItem("caret-right", "rgb(54, 162, 235)", "Transfers Initiated", <Text4>{getCummulativeCount(transfers, statuses)} transactions worth <strong>₹ {`${cummulativeTotal.integer}${cummulativeTotal.decimal ? `.${cummulativeTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("exclamation", "rgb(255, 193, 7)", "Transfers In-Process", <Text4>{getCountData(transfers, "in_process")} transactions worth <strong>₹ {`${inProcessTotal.integer}${inProcessTotal.decimal ? `.${inProcessTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("check", "rgb(40, 167, 69)", "Transfers Processed", <Text4>{getCountData(transfers, "success")} transactions worth <strong>₹ {`${successTotal.integer}${successTotal.decimal ? `.${successTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("close", "rgb(220, 23, 69)", "Transfers Failed", <Text4>{getCountData(transfers, "failure")} transactions worth <strong>₹ {`${failureTotal.integer}${failureTotal.decimal ? `.${failureTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Commission Earned", <Text4><strong>₹ {`${earnings.integer}${earnings.decimal ? `.${earnings.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Payable Commission", <Text4><strong>₹ {`${payable_commission.integer}${payable_commission.decimal ? `.${payable_commission.decimal}` : ""}`} /-</strong></Text4>)}
            </List>
        )
    };


    const renderVAInsights = () => {
        
        const cva_count = insightsData.cva_commissions ? insightsData.cva_commissions.totals : 0
        const earnings = getIndianRupeeNotation(insightsData.cva_commissions? insightsData.cva_commissions.earnings : 0.00 || 0.00);
        const payable_commission = getIndianRupeeNotation(insightsData.cva_commissions? insightsData.cva_commissions.payable_commission : 0.00 || 0.00);

        return (
            <List itemLayout="horizontal" loading={isLoading}>
                {renderListItem("caret-right", "rgb(54, 162, 235)", "Virtual Accounts Created", <Text4>{cva_count}</Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Commission Earned", <Text4><strong>₹ {`${earnings.integer}${earnings.decimal ? `.${earnings.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Payable Commission", <Text4><strong>₹ {`${payable_commission.integer}${payable_commission.decimal ? `.${payable_commission.decimal}` : ""}`} /-</strong></Text4>)}
            </List>
        )
    };
    const renderTransactionsInsights = () => {
        const cva_transaction = insightsData.cva_transaction_commissions
        const statuses = [1, 2, 3]
        const cummulativeTotal = getIndianRupeeNotation(parseFloat(getCummulativeTotal(cva_transaction, statuses)));
        const earnings = getIndianRupeeNotation(cva_transaction ? cva_transaction.earnings : 0.00 || 0.00);
        const payable_commission = getIndianRupeeNotation(cva_transaction ? cva_transaction.payable_commission : 0.00 || 0.00);

        return (
            <List itemLayout="horizontal" loading={isLoading}>
                {renderListItem("caret-right", "rgb(54, 162, 235)", "Total Transactions", <Text4>{getCummulativeCount(cva_transaction, statuses)} transactions worth <strong>₹ {`${cummulativeTotal.integer}${cummulativeTotal.decimal ? `.${cummulativeTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Commission Earned", <Text4><strong>₹ {`${earnings.integer}${earnings.decimal ? `.${earnings.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Payable Commission", <Text4><strong>₹ {`${payable_commission.integer}${payable_commission.decimal ? `.${payable_commission.decimal}` : ""}`} /-</strong></Text4>)}
            </List>
        )
    };
    const renderSettlementsInsights = () => {
        const settelments = insightsData.settelment_commissions
        const statuses = [1, 2, 3, 4]
        const cummulativeTotal = getIndianRupeeNotation(parseFloat(getCummulativeTotal(settelments, statuses)));
        const inPendigTotal = getIndianRupeeNotation(getTotalData(settelments, 1));
        const inProcessTotal = getIndianRupeeNotation(getTotalData(settelments, 2));
        const successTotal = getIndianRupeeNotation(getTotalData(settelments, 4));
        const failureTotal = getIndianRupeeNotation(getTotalData(settelments, 3));
        const earnings = getIndianRupeeNotation(settelments ? settelments.earnings : 0.00 || 0.00);
        const payable_commission = getIndianRupeeNotation(settelments ? settelments.payable_commission : 0.00 || 0.00);

        return (
            <List itemLayout="horizontal" loading={isLoading}>
                {renderListItem("caret-right", "rgb(54, 162, 235)", "Settlements Initiated", <Text4>{getCummulativeCount(settelments, statuses)} transactions worth <strong>₹ {`${cummulativeTotal.integer}${cummulativeTotal.decimal ? `.${cummulativeTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("exclamation", "rgb(255, 193, 7)", "Settlements Pending", <Text4>{getCountData(settelments, 1)} transactions worth <strong>₹ {`${inPendigTotal.integer}${inPendigTotal.decimal ? `.${inPendigTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("exclamation", "rgb(255, 193, 7)", "Settlements In-Process", <Text4>{getCountData(settelments, 2)} transactions worth <strong>₹ {`${inProcessTotal.integer}${inProcessTotal.decimal ? `.${inProcessTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("check", "rgb(40, 167, 69)", "Settlements Processed", <Text4>{getCountData(settelments, 4)} transactions worth <strong>₹ {`${successTotal.integer}${successTotal.decimal ? `.${successTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("close", "rgb(220, 23, 69)", "Settlements Failed", <Text4>{getCountData(settelments, 3)} transactions worth <strong>₹ {`${failureTotal.integer}${failureTotal.decimal ? `.${failureTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Commission Earned", <Text4><strong>₹ {`${earnings.integer}${earnings.decimal ? `.${earnings.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Payable Commission", <Text4><strong>₹ {`${payable_commission.integer}${payable_commission.decimal ? `.${payable_commission.decimal}` : ""}`} /-</strong></Text4>)}
            </List>
        )
    };
    const renderRefundsInsights = () => {
        const refund = insightsData.refund_commissions
        const statuses = [1, 2, 3, 4]
        const cummulativeTotal = getIndianRupeeNotation(parseFloat(getCummulativeTotal(refund, statuses)));
        const inPendigTotal = getIndianRupeeNotation(getTotalData(refund, 1));
        const inProcessTotal = getIndianRupeeNotation(getTotalData(refund, 2));
        const successTotal = getIndianRupeeNotation(getTotalData(refund, 4));
        const failureTotal = getIndianRupeeNotation(getTotalData(refund, 3));
        const earnings = getIndianRupeeNotation(refund ? refund.earnings : 0.00 || 0.00);
        const payable_commission = getIndianRupeeNotation(refund ? refund.payable_commission : 0.00 || 0.00);

        return (
            <List itemLayout="horizontal" loading={isLoading}>
                {renderListItem("caret-right", "rgb(54, 162, 235)", "Refunds Initiated", <Text4>{getCummulativeCount(refund, statuses)} transactions worth <strong>₹ {`${cummulativeTotal.integer}${cummulativeTotal.decimal ? `.${cummulativeTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("exclamation", "rgb(255, 193, 7)", "Refunds Pending", <Text4>{getCountData(refund, 1)} transactions worth <strong>₹ {`${inPendigTotal.integer}${inPendigTotal.decimal ? `.${inPendigTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("exclamation", "rgb(255, 193, 7)", "Refunds In-Process", <Text4>{getCountData(refund, 2)} transactions worth <strong>₹ {`${inProcessTotal.integer}${inProcessTotal.decimal ? `.${inProcessTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("check", "rgb(40, 167, 69)", "Refunds Processed", <Text4>{getCountData(refund, 4)} transactions worth <strong>₹ {`${successTotal.integer}${successTotal.decimal ? `.${successTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("close", "rgb(220, 23, 69)", "Refunds Failed", <Text4>{getCountData(refund, 3)} transactions worth <strong>₹ {`${failureTotal.integer}${failureTotal.decimal ? `.${failureTotal.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Commission Earned", <Text4><strong>₹ {`${earnings.integer}${earnings.decimal ? `.${earnings.decimal}` : ""}`} /-</strong></Text4>)}
                {renderListItem("", "rgb(40, 167, 69)", "Payable Commission", <Text4><strong>₹ {`${payable_commission.integer}${payable_commission.decimal ? `.${payable_commission.decimal}` : ""}`} /-</strong></Text4>)}
            </List>
        )
    };

    const instaCollectInsights = [
        { key: "2", tab: "InstaCollect Virtual Accounts", data: renderVAInsights },
        { key: "3", tab: "InstaCollect Transactions", data: renderTransactionsInsights },
        { key: "4", tab: "InstaCollect Settlements", data: renderSettlementsInsights },
        { key: "5", tab: "InstaCollect Refunds", data: renderRefundsInsights },
    ]

    return (
        <EaseDrawer
            className="merchant-insights-wrapper"
            title={false}
            width={550}
            visible={props.visible}
            onOpen={() => { setFilters({ ...filters, month: moment() }); fetchInsights({ ...filters, month: moment() }) }}
            onClose={props.toggleInsightsDrawer}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div className="mt-3">
                {renderTitle()}
                {renderFilters()}
                <Tabs defaultActiveKey="1" >
                    <TabPane tab="Transfers" key="1">{renderTransferInsights()}</TabPane>
                    {!isEmpty(props.merchant.smart_collect_virtual_accounts) &&
                        instaCollectInsights.map((insight) => {
                            return <TabPane tab={insight.tab} key={insight.key}>{insight.data()}</TabPane>
                        })
                    }
                </Tabs>
            </div>
        </EaseDrawer>
    )
};

export { MerchantInsightsDrawer };